module.exports = __webpack_public_path__ + "img/icon-manager.8417d0c1.svg";